import { Injectable } from "@angular/core";
import { environment } from "@env/environment";
import { Observable } from "rxjs";
import { io } from "socket.io-client";
import { CurrentConsultationResponse } from "./consultations.model";

@Injectable({
    providedIn: "root",
})
export class ActiveConsultationSocketService {
    listenDiagnosis(consultationId: string) {
        return new Observable<Partial<CurrentConsultationResponse>>((observer) => {
            const socket = io(environment.consultasSocketURL, {
                path: environment.consultasSocketPath,
                auth: { consultationId },
            });

            socket.on("notify-diagnosis", (payload: unknown) => observer.next(this.extractConsultationPayload(payload)));
            socket.on("connect_error", (error: Error) => observer.error(error));

            return () => {
                socket.off("notify-diagnosis");
                socket.off("connect_error");
                socket.disconnect();
            };
        });
    }

    private extractConsultationPayload(payload: unknown): Partial<CurrentConsultationResponse> {
        if (!payload || typeof payload !== "object") return {};

        const data = payload as Record<string, unknown>;
        const nested = data["consultation"] || data["data"];

        return nested && typeof nested === "object"
            ? nested as Partial<CurrentConsultationResponse>
            : data as Partial<CurrentConsultationResponse>;
    }
}
